// extracted by mini-css-extract-plugin
export default {"confirm":"styles_confirm__zDtDw","title":"styles_title__rHnq7","btn":"styles_btn__rHHhc"};